import { useEffect, useState } from "react";

const KEY = "gadopro:theme";

function resolve(pref) {
  if (pref === "dark") return "dark";
  if (pref === "light") return "light";
  return typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

function apply(mode) {
  const root = document.documentElement;
  if (mode === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

export function useTheme() {
  const [pref, setPref] = useState(() => {
    if (typeof window === "undefined") return "system";
    return localStorage.getItem(KEY) || "system";
  });

  useEffect(() => {
    apply(resolve(pref));
  }, [pref]);

  // Follow system preference changes when user chose "system"
  useEffect(() => {
    if (pref !== "system" || typeof window === "undefined") return;
    const m = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => apply(resolve("system"));
    m.addEventListener?.("change", handler);
    return () => m.removeEventListener?.("change", handler);
  }, [pref]);

  const setTheme = (v) => {
    setPref(v);
    if (typeof window !== "undefined") localStorage.setItem(KEY, v);
  };

  const effective = resolve(pref);
  return { pref, effective, setTheme, toggle: () => setTheme(effective === "dark" ? "light" : "dark") };
}

// Initialise before React mounts to avoid flash-of-light on reload
export function bootstrapTheme() {
  try {
    const pref = localStorage.getItem(KEY) || "system";
    apply(resolve(pref));
  } catch {
    /* ignore */
  }
}
